export default __webpack_public_path__ + "static/media/our-services-01.0634422f.jpg";